import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { api, ApiError } from '../lib/api';
import { Logo } from '../components/Logo';

/**
 * أوّلُ دخولٍ بكلمةٍ مؤقّتة — كلمةٌ جديدة قبل أيّ شاشة.
 *
 * المؤقّتةُ وصلت في بريدٍ أو سُلّمت باليد، فهي معروفةٌ لغير صاحبها. لا
 * يُفتح النظامُ حتى يستبدلها بكلمةٍ لا يعرفها سواه — ولا تُطلب «الحالية»:
 * الغرضُ إبطالُها لا تأكيدُها.
 */
export function SetPassword() {
  const { reload, logout } = useAuth();
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const mismatch = confirm.length > 0 && next !== confirm;
  const valid = next.length >= 10 && next === confirm;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!valid) return;
    setError(null);
    setBusy(true);
    try {
      await api('/auth/set-password', { method: 'POST', body: { newPassword: next } });
      await reload();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'تعذّر الاتصال بالخادم.');
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login-card" onSubmit={onSubmit} noValidate>
        <div className="login-brand">
          <Logo size={34} />
          <span>GoyOne</span>
        </div>
        <h1 className="card-title">اختر كلمة مرورك</h1>
        <p className="small mute">
          دخلتَ بكلمةٍ مؤقّتة. اختر كلمةً جديدة لا يعرفها غيرك — عشرة أحرف على الأقل — ولن تعمل
          المؤقّتةُ بعدها.
        </p>

        {error && <div className="alert alert-danger">{error}</div>}

        <label className="field">
          <span className="label req">كلمة المرور الجديدة</span>
          <input
            className="input"
            type="password"
            dir="ltr"
            autoComplete="new-password"
            autoFocus
            value={next}
            onChange={(e) => setNext(e.target.value)}
          />
        </label>
        <label className="field">
          <span className="label req">تأكيد كلمة المرور</span>
          <input
            className="input"
            type="password"
            dir="ltr"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          {mismatch && <span className="tiny neg">الكلمتان غير متطابقتين.</span>}
        </label>

        <button className="btn btn-primary" type="submit" disabled={!valid || busy}>
          {busy ? 'جارٍ الحفظ…' : 'حفظ والدخول'}
        </button>
        <button className="btn btn-ghost" type="button" onClick={() => void logout()}>
          تسجيل الخروج
        </button>
      </form>
    </div>
  );
}
